export interface BatchUploadFiguresRequest {
    taskId: string;
    form: FormData;
}

export interface BatchUploadFiguresUploadedFile {
    file_url: string
    file_size: number
    content_type: string
    s3_key: string
    unique_id: string
}

export interface UploadedFailedFile {
    original_name: string;
    error_message: string;
    error_code: number;
    file_size: number;
}

export interface BatchUploadFiguresResponse {
    uploaded_files: BatchUploadFiguresUploadedFile[]
    failed_files: UploadedFailedFile[]
    total_count: number
    success_count: number
    failed_count: number
}

export const BatchUploadFiguresApi = Symbol.for('BatchUploadFiguresApi');


export interface BatchUploadFiguresApi {
    batchUploadFigures(request: BatchUploadFiguresRequest): Promise<BatchUploadFiguresResponse>;
}
